export default {
  "content": "<path d=\"M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24\" class=\"ionicon-fill-none ionicon-stroke-width\"/><rect x=\"128\" y=\"240\" width=\"256\" height=\"208\" rx=\"24.32\" ry=\"24.32\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"392\" cy=\"184\" r=\"24\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};